export const termsOfUseHeTranslations = {
  terms_of_use: 'תנאי שימוש',
  last_updated: 'עדכון אחרון',
  terms_of_use_date: '22 בנובמבר 2025',
  go_back: 'חזור',
  terms_of_use_content: {
    company_name: 'Intera-AI',
    system_name: 'Intera - Internal Relationship Management',
    introduction: {
      title: 'תנאי שימוש במערכת',
      welcome:
        'ברוכים הבאים למערכת Intera ("המערכת") של חברת Intera-AI Ltd. ("החברה").',
      terms: 'השימוש במערכת כפוף לתנאי שימוש אלה.',
      privacy_policy:
        'תנאי שימוש אלה כוללים גם מדיניות פרטיות, שמתפרסמת במערכת (קישור מופיע בתחתית כל דף בה) ושמהווה חלק בלתי נפרד מהם.',
      important_notice:
        'נא קראו את תנאי שימוש אלה ואת מדיניות הפרטיות (שלהלן יקראו ביחד :"תנאי השימוש") בעיון בטרם תשתמשו במערכת, שכן הם מהווים חוזה מחייב בינכם לבין החברה ושימושכם במערכת מעיד על הסכמתכם להם.',
      updates_notice:
        'נא גם חזרו וקראו את תנאי השימוש מעת לעת משום שתנאיהם עשויים להשתנות (אנו נדאג לעדכן בכותרת תנאי שימוש אלה ובמדיניות הפרטיות את מועד העדכון האחרון שנעשה בהם).',
      agreement_notice:
        'ככל שאינכם מסכימים לתנאי השימוש עליכם להימנע מכל שימוש במערכת.',
      contact:
        'אתם מוזמנים לפנות אלינו לכל שאלה או הערה בקשר עם תנאי השימוש או בקשר עם המערכת בדוא"ל לכתובת: team@intera-ai.io.',
    },
    terms_for_use: {
      title: 'תנאים לשימוש במערכת',
      authorized_use:
        'שימוש במערכת מותר למשתמשים מורשים בלבד מטעם הארגון בו הם עובדים, למטרות להן היא נועדה בלבד ובכפוף לתנאי השימוש.',
      prohibited_use:
        "מבלי למעט מהאמור בסעיף 2.1 חל איסור על כל שימוש בלתי חוקי במערכת לרבות פרסום תכנים פוגעים, תכנים פורנוגרפיים, תכנים מפרים זכויות קניין רוחני של צדדים שלישיים, תכנים מעוולים לרבות תכנים שיש בהם פגיעה בפרטיות, תכנים המעודדים לגזענות, לאפליה, לאלימות או לכל מעשה לא חוקי אחר, העלאת קבצים זדוניים (רוגלות, נוזקות וכו') או תכנים שיש בהם עידוד לעשות מעשים כאמור.",
      monitoring_rights:
        'מובהר שהגם שהחברה אינה מנטרת את תוכן התכנים שמשתמשים מעלים למערכת, היא שומרת על זכותה לעשות כן, ועל מלוא זכויותיה, כלפי משתמשים שיפרו את תנאי השימוש. בכלל זאת, החברה תהא רשאית, אך לא חייבת להשהות או לחסום גישת משתמשים למערכת.',
    },
    maintenance_and_support: {
      title: 'תחזוקה ותמיכה',
      maintenance:
        'תחזוקה. החברה תפעל בחריצות לתקן בהקדם הסביר כל ליקוי במערכת שיתגלה במערכת, או ככל שהליקוי אינו בר תיקון למצוא לו פתרון חלופי בתוך זמן סביר. קריאות תחזוקה יש לעשות באמצעות כלי הפניה שבמערכת (או באמצעות דואר אלקטרוני לכתובת: team@intera-ai.io).',
      maintenance_description:
        'חשוב ללוות פניות תחזוקה באמצעות תיאורים מספקים ובמידת האפשר צילומי מסך על מנת לאפשר לחברה להבין את פשר התקלה ולספק מענה יעיל ומהיר.',
      support:
        'תמיכה. משתמשים רשאים לפנות לחברה בפניות תמיכה באמצעות כלי הפניה שבמערכת (או בדואר אלקטרוני לכתובת: team@intera-ai.io). קריאות תמיכה יענו בתוך יום עבודה (תוך שהחברה נוקטת אמצעים על מנת שזמן המענה לרוב קריאות התמיכה יהיה מהיר מיום עבודה).',
    },
    the_system: {
      title: 'המערכת',
      purpose: 'המערכת מיועדת לניהול תקשורת פנים ארגונית בענייני עבודה.',
      communication_channel:
        'המערכת היא ערוץ תקשורת נוסף לערוצי תקשורת שבין עובדי ארגונים. המערכת כוללת כלים שונים לתקשור בין משתמשים, שמיועדים לאפשר שיח ענייני בענייני עבודה.',
      service_provision:
        'המערכת מסופקת כשירות מקוון מאתר החברה בכתובת: https://www.intera-ai.io והגישה אליה היא באמצעות דפדפן.',
      access_and_use:
        'גישה ושימוש. הגישה למערכת והשימוש בה נעשים באמצעות חשבונות משתמשים.',
      user_accounts: {
        title: 'חשבונות משתמשים מוקצים על ידי הארגון בו המשתמשים עובדים:',
        admin_user:
          'משתמש מנהל מטעם הארגון שהתקשר עם החברה ("משתמש מנהל") הוא שקובע (בהתאם לכמות הרישיונות שנרכשה על ידי הארגון) אלו חשבונות משתמשים יוקמו, את השיוך הארגוני ואת הרשאות השימוש של כל משתמש.',
        account_management:
          'מחיקה, הוספה או שינוי הרשאות משתמשים נעשים על ידי המשתמש המנהל, באמצעות כלי ניהול שבמערכת או באמצעות מתן הנחיות לחברה.',
      },
      updates_and_changes: {
        title: 'עדכונים ושינויים למערכת',
        content:
          'החברה עשויה לבצע מעת לעת עדכונים ושינויים במערכת. תכלית העדכונים והשינויים היא לרוב לשפר פונקציות קיימות ולהוסיף חדשות, עם זאת החברה שומרת על זכותה להחליף או להפסיק פונקציות מסוימות במקרים כאמור החברה תמסור על כך הודעה מוקדמת.',
      },
      system_availability: {
        title: '',
        content:
          'המערכת מוצעת לשימוש כפי שהיא. הגם שהחברה נוקטת אמצעים סבירים על מנת שהמערכת תהיה זמינה, נגישה, נקיה מליקויים, משיבושים טכנולוגיים או מטעויות, בכל עת, היכולת המעשית לעשות כן מוגבלת, והחברה אינה מתחייבת שהמערכת תהיה זמינה, נגישה, נקיה מליקויים, משיבושים טכנולוגיים או מטעויות בכל עת, או שהמערכת תענה על כל צרכיכם או ציפיותיכם.',
      },
    },
    maintenance: {
      title: 'תחזוקה',
      maintenance_requests:
        'משתמשים רשאים לפנות לחברה בפניות תחזוקה באמצעות כלי הפניה שבמערכת (או באמצעות דואר אלקטרוני לכתובת :team@intera-ai.io).',
      maintenance_description:
        'חשוב ללוות פניות תחזוקה באמצעות תיאורים מספקים ובמידת האפשר צילומי מסך על מנת לאפשר לחברה להבין את פשר התקלה ולספק מענה יעיל ומהיר.',
    },
    support: {
      title: 'תמיכה',
      support_requests:
        'משתמשים רשאים לפנות לחברה בפניות תמיכה באמצעות כלי הפניה שבמערכת (או בדואר אלקטרוני לכתובת : team@intera-ai.io).',
      response_time:
        'קריאות תמיכה יענו בתוך יום עבודה (תוך שהחברה נוקטת אמצעים על מנת שזמן המענה לרוב קריאות התמיכה יהיה מהיר מיום עבודה).',
    },
    intellectual_property: {
      title: 'קניין רוחני',
      ownership:
        'מלוא זכויות הקניין הרוחני במערכת, לרבות בקוד המערכת ובתכנים המתפרסמים בה (למעט תכני משתמשים במערכת) הינם בבעלות החברה או בבעלות צדדים שלישיים שהתירו לחברה להשתמש בו. זכויות קניין רוחני - לרבות : פטנטים ובקשות לפטנטים, זכות יוצרים, שמות וסימני מסחר, שם מתחם, סודות מסחר, מדגמים וכל זכות קניין רוחני אחרת רשומה, שאינה רשומה או שהיא ברת רישום, בישראל או בכל מקום אחר בעולם.',
      prohibition:
        'אין לבצע כל פעולה שיש בה להפר את זכויות הקניין הרוחני של החברה במערכת.',
      system_disruption:
        'חל איסור לבצע כל פעולה שעלולה לשבש את פעילות המערכת, לפגוע במשתמשים בה או לחשוף מידע אודותיהם, לרבות ומבלי למעט : ביצוע מתקפות, העלאת קוד זדוני, החדרת רוגלות או נוזקות בכל אופן שהוא.',
    },
    company_liability: {
      title: 'אחריות החברה',
      liability_scope:
        'אחריות החברה היא לספק המערכת כשירות בהתאם לתנאי השימוש. החברה לא תהיה אחראית לכל נזק שהוא (לרבות : ישיר, עקיף, תוצאתי מיוחד או מכל מין אחר שהוא), הפסד, הוצאה, אי נוחות או אבדן שיגרם כתוצאה מהשימוש במערכת, לרבות מחוסר היכולת להשתמש בה ובלבד שהיא לא פעלה בזדון או במרמה.',
    },
    terms_update: {
      title: 'עדכון תנאי השימוש',
      update_rights:
        'החברה שומרת לעצמה את הזכות לשנות את תנאי השימוש מעת לעת ככל שהדבר נדרש לצורך התאמתם לדין, תפעול יעיל ומאובטח של המערכת וכן במקרים עדכונים או שינויים שיעשו במערכת ככל שהדבר נדרש לדעתה הסבירה של החברה. שינוי תנאי השימוש ייעשה על ידי עדכונם וציון מועד העדכון בכותרת תנאי השימוש.',
      continued_use:
        'המשך שימוש במערכת לאחר עדכון התנאים מעיד על הסכמה לתנאים המעודכנים. ככל שלא תסכימו לתנאים המעודכנים עליכם להימנע מכל שימוש במערכת.',
    },
    law_and_jurisdiction: {
      title: 'דין ומקום שיפוט',
      applicable_law:
        'על השימוש באתר לרבות כל עניין בקשר עם תנאי השימוש יחולו דיני מדינת ישראל בלבד (ומבלי ליתן תוקף להפניות לדינים אחרים). לבתי המשפט המוסמכים בתל אביב תהא סמכות השיפוט הבלעדית בכל עניין בקשר עם השימוש במערכת.',
    },
  },
} as const;
